import React, { useState } from "react"

import HamburgerNav from "./Header/HamburgerNav"
import { Link, withRouter } from "react-router-dom"
import { MainNavigationTree, getActivePath } from "RouteHelper"
import NavListItem from "./Header/NavListItem"
import UserPanel from "./Header/UserPanel"
import { connect } from "react-redux"
import logoImg from "assets/img/logo.png"
import logoImgGraphic from "assets/img/logo-graphic.png"
import logoImgText from "assets/img/logo-text.png"

/**
 * Main app Header
 */
const Header = (props) => {
    const [state, setState] = useState({
        // selectedMainNavItem: MainNavigationTree[1],
        selectedMainNavItem: getActivePath(props.location.pathname),
        selectedSubNavItem: getActivePath(props.location.pathname, 2)
    });

    // Renders main navigation items
    const renderMainNavNodes = () => {
        let navNodes = []

        const navItems =
            MainNavigationTree && MainNavigationTree.length
                ? MainNavigationTree
                : null

        if (navItems) {
            navNodes = navItems.map(navItem => {
                const routeDef = navItem.routeDefinition
                return (
                    <NavListItem
                        className="main"
                        key={routeDef.key}
                        path={routeDef.path === "/" ? routeDef.path : null}
                        isActive={state.selectedMainNavItem === navItem}
                        onClick={() =>
                            changeSelectedMainNavItem(navItem)
                        }
                        icon={
                            <i
                                className={`icon ${
                                    routeDef.icon
                                        ? routeDef.icon
                                        : "fal fa-link"
                                }`}
                            />
                        }
                        title={routeDef.title}
                    />
                )
            })
        }

        return navNodes
    }

    // Renders subnavigation items for current main item
    const renderSubNavNodes = () => {
        let navNodes = []

        const navItems =
            state.selectedMainNavItem &&
            state.selectedMainNavItem.children &&
            state.selectedMainNavItem.children.length
                ? state.selectedMainNavItem.children
                : null

        // ADD support for not showing all route definitions as subnavnode
        if (navItems) {
            navNodes = navItems.reduce((acc, curr) => {
                const routeDef = curr.routeDefinition
                if (!routeDef.hidden) {
                    acc.push(
                        <NavListItem
                            className="sub"
                            key={routeDef.key}
                            path={routeDef.path}
                            isActive={
                                state.selectedSubNavItem === routeDef
                            }
                            isDisabled={routeDef.path ? false : true}
                            title={routeDef.title}
                            onClick={() =>
                                changeSelectedSubNavItem(routeDef)
                            }
                        />
                    )
                }
                return acc
            }, [])
        }

        return navNodes
    }

    // Changes selected main navigation item
    const changeSelectedMainNavItem = (navItem) => {
        if (state.selectedMainNavItem !== navItem) {
            setState({
                selectedMainNavItem: navItem
            })
        }
    }

    // Changes selected main navigation item
    const changeSelectedSubNavItem = (navItem) => {
        if (state.selectedSubNavItem !== navItem) {
            setState({
                selectedSubNavItem: navItem
            })
        }
    }

    return (
        <div className="header">
            <div className="logo">
                <Link to="/">
                    <span className="logo-single">
                        <img src={logoImg} alt="The Guard" />
                    </span>
                    <span className="logo-split">
                        <img
                            className="logo-split-graphic"
                            src={logoImgGraphic}
                            alt="The Guard"
                        />
                        <img
                            className="logo-split-text"
                            src={logoImgText}
                            alt="The Guard"
                        />
                    </span>
                </Link>
            </div>
            <div className="nav-panel">
                <div className="top-nav-panel">
                    <div className="main-nav">
                        <ul>{renderMainNavNodes()}</ul>
                    </div>
                    <div className="user-nav">
                        <UserPanel />
                    </div>
                    <div className="hamburger-nav">
                        <HamburgerNav />
                    </div>
                </div>
                <div className="sub-nav">
                    <ul>{renderSubNavNodes()}</ul>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state /* , ownProps */) => ({});

const mapDispatchToProps = {};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Header)
);
